/**
 * Signup date for the admin Users table.
 *
 * Canonical field is `users.dateSignedUp` (epoch ms). Email/password signup
 * historically wrote only `createdAt` as an ISO string, so that is a valid
 * fallback for *this user*. Organization `createdAt` is not — a member can
 * join an org that was created years earlier.
 */

function toEpochMs(value) {
  if (value == null || value === "") {
    return null;
  }

  if (typeof value.toDate === "function") {
    const date = value.toDate();

    return Number.isNaN(date.getTime()) ? null : date.getTime();
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.getTime();
  }

  if (typeof value === "object" && Number.isFinite(value.seconds)) {
    return value.seconds * 1000;
  }

  if (typeof value === "number" && Number.isFinite(value) && value > 0) {
    return value < 1e12 ? value * 1000 : value;
  }

  if (typeof value === "string") {
    const parsed = Date.parse(value);

    return Number.isNaN(parsed) ? null : parsed;
  }

  return null;
}

/**
 * @param {object} [user]
 * @returns {number|null} epoch ms
 */
export function resolveSignedUpAt(user = {}) {
  return toEpochMs(user.dateSignedUp) || toEpochMs(user.createdAt) || null;
}

export function formatSignedUpDate(user) {
  const epochMs = resolveSignedUpAt(user);

  if (!epochMs) {
    return null;
  }

  return new Date(epochMs).toLocaleDateString();
}
